import { render } from "./UserPermissionUpdate.vue?vue&type=template&id=2b132157&ts=true"
import script from "./UserPermissionUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPermissionUpdate.vue?vue&type=script&setup=true&lang=ts"

import "./UserPermissionUpdate.vue?vue&type=style&index=0&id=2b132157&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/userinfo/UserPermissionUpdate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b132157"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b132157', __exports__)) {
    console.log('reload')
    api.reload('2b132157', __exports__)
  }
  
  module.hot.accept("./UserPermissionUpdate.vue?vue&type=template&id=2b132157&ts=true", () => {
    console.log('re-render')
    api.rerender('2b132157', render)
  })

}


export default __exports__